<template>
  <div class="login-view">
    <div class="container mx-auto text-center mt-20">
      <div class="flex justify-center"><schneidergruppe color="#000" /></div>
      <h1 class="font-bold text-xl mt-4">Fahrzeugsuche</h1>
      <p class="mt-6 text-grey-darker">Bitte melden Sie sich mit Ihrem Schneider-Konto an.</p>
      <button
        @click="anmelden"
        class="mt-4 bg-schneider-petrol hover:bg-schneider-petrol-light text-white font-bold py-2 px-6 rounded-md"
        type="button"
      >
        Mit Schneider-Konto anmelden
      </button>
      <p class="text-red mt-4" v-if="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import oidc from "../../auth/oidc";
export default {
  data() {
    return { error: null };
  },
  methods: {
    async anmelden() {
      try {
        await oidc.login();
      } catch (e) {
        console.error(e);
        this.error = "Anmeldung konnte nicht gestartet werden.";
      }
    },
  },
};
</script>

<style></style>
